<template>
  <v-raw>
    <v-col
      v-for="game_round in game.rounds"
      :key="game_round.uuid"
      cols="12"
      class="flex justify-center"
    >
      <v-card
        class="game-card"
      >
        <v-row>
          <v-col
            cols="4"
            class="game-date"
          >
            <div>
              <v-img 
                :src="imagePath(game_round.game_id, game.name)"
              />
            </div>
            <span>{{ safeDate(game_round.round_rooms[0] && game_round.round_rooms[0].win_number && game_round.round_rooms[0].win_number.created_at) }}</span>
          </v-col>
          <v-col
            cols="8"
            class="game-info"
          >
            <div class="game-round">
              <span class="py-1 mx-3 white--text">{{ game_round.name }}</span>
            </div>
            <v-row>
              <v-col
                cols="6"
                class="number-info"
              >
                <strong class="number-info--title">รางวัลที่ 1</strong>
                <v-divider class="number-info--space"></v-divider>
                <span class="number-info--result">{{ game_round.round_rooms[0] && game_round.round_rooms[0].win_number && game_round.round_rooms[0].win_number.win_number || 'xxxxxx' }}</span>
              </v-col>
              <v-col
                cols="6"
                class="number-info"
              >
                <strong class="number-info--title">เลขท้าย 2 ตัว</strong>
                <v-divider class="number-info--space"></v-divider>
                <span class="number-info--result">{{ game_round.round_rooms[0] && game_round.round_rooms[0].win_number && game_round.round_rooms[0].win_number.two_down || 'xx' }}</span>
              </v-col>
              <v-col
                cols="6"
                class="number-info"
              >
                <strong class="number-info--title">เลขหน้า 3 ตัว</strong>
                <v-divider class="number-info--space"></v-divider>
                <span class="number-info--result">
                  {{ game_round.round_rooms[0] && game_round.round_rooms[0].win_number && game_round.round_rooms[0].win_number.three_down_first || 'xxx' }} | 
                  {{ game_round.round_rooms[0] && game_round.round_rooms[0].win_number && game_round.round_rooms[0].win_number.three_down_second || 'xxx' }}
                </span>
              </v-col>
              <v-col
                cols="6"
                class="number-info"
              >
                <strong class="number-info--title">เลขท้าย 3 ตัว</strong>
                <v-divider class="number-info--space"></v-divider>
                <span class="number-info--result">
                  {{ game_round.round_rooms[0] && game_round.round_rooms[0].win_number && game_round.round_rooms[0].win_number.three_down_third || 'xxx' }} | 
                  {{ game_round.round_rooms[0] && game_round.round_rooms[0].win_number && game_round.round_rooms[0].win_number.three_down_fourth || 'xxx' }}
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-raw>
</template>
<script>
import { imagePath } from '@/plugins/mapImage' 

export default {
  props : {
    game : {
      type: Object,
      default: () => ({})
    },
  },
  methods: {
    imagePath,
    safeDate (date) {
      return date ? this.$options.filters.dateOnlyFormat(date) : '-';
    }
  },
}
</script> 
<style>
.game-card {
  max-width: 480px;
  padding: 1rem;
  border-radius: 12px !important;
  box-shadow: unset !important;
}

.game-date {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.game-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.game-round {
  background-color: var(--bg-main-color) !important;
  border-radius: 12px;
  font-size: 1.5rem;
}

.number-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
}

.number-info--space {
  width: 75%;
}

.number-info--result {
  font-size: 1.5rem;
  color: var(--bg-main-color) !important;
}

@media only screen and (max-width: 450px) {
  .game-date {
    font-size: 14px;
  }

  .number-info--title {
    font-size: 14px;
  }

  .number-info--result {
    font-size: 1.25rem;
  }
}
</style>